<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />
    
    <!-- นำทาง -->
    <v-card elevation="0" class="v-card-bottom-30">
      <v-card-title class="body-1">
        {{ use_language.product }}
        <v-icon>mdi-chevron-right</v-icon>
        {{ use_language.promote_product }}
      </v-card-title>
    </v-card>

    <!-- queue boost -->
    <v-card elevation="0" class="v-card-bottom-30">
      <v-card-title>
        <v-icon color="blue" size="24">mdi-speedometer</v-icon>
        <span class="ml-2">{{ use_language.product_that }} Boost</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="openProductForBoost">{{ use_language.add_product_to }} Boost</v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <div style="align-items: center" class="d-flex pb-3">
          <v-btn @click="btnPrepareRemoveProduct" color="primary" small :disabled="productBoostMasterSelect.length == 0">
            {{ use_language.remove_from }} Boost
          </v-btn>
          <v-spacer/>
          <div>{{ use_language.all_ }} {{productBoostTotal}}</div>
        </div>
        <v-data-table
          v-model="productBoostMasterSelect"
          :headers="productBoostMasterHeaders"
          :items="productBoostMasterList"
          item-key="id"
          show-expand
          :expanded.sync="expandedBoost"
          hide-default-footer
          class="packhai-border-table"
          :single-select="false" 
          show-select
          :items-per-page="10000"
        >
          <template v-slot:item.isBookmark="{ item }">
            <a v-if="productBoostMasterList.filter(i => i.isBookmark).length < 5" @click="btnPrepareBookmark(item)">
              <v-icon size="26" color="primary">
                {{ item.isBookmark ? 'mdi-bookmark-check' : 'mdi-bookmark-outline' }}
              </v-icon>
            </a>
            <a v-else-if="productBoostMasterList.filter(i => i.isBookmark).length == 5 && item.isBookmark" @click="btnPrepareBookmark(item)">
              <v-icon size="26" color="primary">
                {{ item.isBookmark ? 'mdi-bookmark-check' : 'mdi-bookmark-outline' }}
              </v-icon>
            </a>
          </template>
          <template v-slot:item.photoLink="{ item }">
            <v-btn v-if="item.photoLink!=null && item.photoLink!=''" icon @click="OpenPhoto(item.photoLink)">
              <img :src="item.photoLink" width="40">
            </v-btn>
          </template>
          <template v-slot:item.name="{ item }">
            <div class="text-left">{{item.name}}</div>
          </template>
          <template v-slot:item.salePrice="{ item }">
            <div class="text-right">{{format_price(item.salePrice)}}</div>
          </template>

          <template v-slot:item.finish="{ item }">
            <div v-if="item.finish != null" class="text-primary">{{formatCountdown(item.finish)}}</div>
          </template>

          <!-- expand -->
          <template v-slot:item.data-table-expand="{ item, expand, isExpanded }">
            <v-icon
              v-if="item.shopeeVariationId != null"
              @click.stop="expand(!isExpanded)"
              style="cursor:pointer"
              size="26"
              color="danger"
            >
              {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div class="pa-3">
                <v-data-table
                  :headers="productSubHeaders"
                  :items="item.items"
                  item-key="id"
                  hide-default-footer
                  class="packhai-border-table"
                  :items-per-page="10000"
                >
                  <template v-slot:item.photoLink="{ item }">
                    <v-btn v-if="item.photoLink!=null && item.photoLink!=''" icon @click="OpenPhoto(item.photoLink)">
                      <img :src="item.photoLink" width="40">
                    </v-btn>
                  </template>
                  <template v-slot:item.name="{ item }">
                    <div class="text-left">{{item.name}}</div>
                  </template>
                  <template v-slot:item.salePrice="{ item }">
                    <div class="text-right">{{format_price(item.salePrice)}}</div>
                  </template>
                </v-data-table>
              </div>
            </td>
          </template>
        </v-data-table>
        <div class="d-flex pt-5" style="align: center">
          <div v-if="isShowAutoBoost == true" class="d-flex">
            <v-checkbox v-model="isAutoBoost" @change="updateAutoBoost" color="red" hide-details></v-checkbox>
            <h4>boost {{ use_language.auto_when_less_than_5 }}</h4>
          </div>
          <v-spacer></v-spacer>
          <v-btn @click="btnSaveChanges" color="primary" :disabled="isSaveChange==false">{{use_language.save_change_log}}</v-btn>
        </div>
      </v-card-text>
    </v-card>
    
    <!-- dialog product select -->
    <v-dialog v-model="dialogAddProductToBoost" scrollable max-width="70%" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1" class="ma-0">
        <loading :loading="stockLoading"/>
        <v-card-title>
          <v-icon size="40" color="teal darken-3">mdi-basket</v-icon>
           <span class="ml-3">{{ use_language.product }}</span>
          <v-spacer/>
          <v-btn icon><v-icon color="danger" @click="closeProductForBoost">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="overflow-y-auto">
          <v-row class="item-center pb-3">
            <v-col cols="12" md="1"   class="pb-3">
              <h3 class="fn-14">{{ use_language.product }} :</h3>
            </v-col>
            <v-col cols="12" md="4"     class="pt-1 pb-2">
              <v-text-field
                v-model="search.name"
                outlined
                dense
                hide-details
                autocomplete="off"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="item-center">
            <v-col cols="12" md="1" class="pb-3">
              <h3 class="fn-14">SKU :</h3>
            </v-col>
            <v-col cols="12" md="4" class="pt-1 pb-2">
              <v-text-field
              v-model="search.sku"
                outlined
                dense
                hide-details
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col >
              <v-btn @click="getProductList()" :elevation="1" color="primary">
                <span class="fn-14"><b>{{ use_language.search }} </b></span>
              </v-btn>
            </v-col>
          </v-row>
          <div class="text-right">{{ use_language.all_ }} {{productTotal}}</div>
          <v-data-table
            v-model="productMasterSelect"
            :headers="productMasterHeaders"
            :items="productMasterList"
            item-key="id"
            show-expand
            :expanded.sync="expanded"
            hide-default-footer
            class="packhai-border-table"
            :single-select="false" 
            show-select
            :items-per-page="10000"
          >
            <template v-slot:item.photoLink="{ item }">
              <v-btn v-if="item.photoLink!=null && item.photoLink!=''" icon @click="OpenPhoto(item.photoLink)">
                <img :src="item.photoLink" width="40">
              </v-btn>
            </template>
            <template v-slot:item.name="{ item }">
              <div class="text-left">{{item.name}}</div>
            </template>
            <template v-slot:item.salePrice="{ item }">
              <div class="text-right">{{format_price(item.salePrice)}}</div>
            </template>

            <!-- expand -->
            <template v-slot:item.data-table-expand="{ item, expand, isExpanded }">
              <v-icon
                v-if="item.shopeeVariationId != null"
                @click.stop="expand(!isExpanded)"
                style="cursor:pointer"
                size="26"
                color="danger"
              >
                {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <div class="pa-3">
                  <v-data-table
                    :headers="productSubHeaders"
                    :items="item.items"
                    item-key="id"
                    hide-default-footer
                    class="packhai-border-table"
                    :items-per-page="10000"
                  >
                    <template v-slot:item.photoLink="{ item }">
                      <v-btn v-if="item.photoLink!=null && item.photoLink!=''" icon @click="OpenPhoto(item.photoLink)">
                        <img :src="item.photoLink" width="40">
                      </v-btn>
                    </template>
                    <template v-slot:item.name="{ item }">
                      <div class="text-left">{{item.name}}</div>
                    </template>
                    <template v-slot:item.salePrice="{ item }">
                      <div class="text-right">{{format_price(item.salePrice)}}</div>
                    </template>
                  </v-data-table>
                </div>
              </td>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn @click="btnCheckStockShopee" color="primary" :disabled="productMasterSelect.length == 0">
                {{ use_language.add_to }} Boost
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog check stock -->
    <v-dialog v-model="dialogCheckStock" scrollable max-width="50%" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1" class="ma-0">
        <v-card-title>
          <v-icon size="40" color="teal darken-3">mdi-basket-check</v-icon>
           <span class="ml-3">{{ use_language.desired_product }} Boost</span>
          <v-spacer/>
          <v-btn icon><v-icon color="danger" @click="closeCheckStockShopee">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="overflow-y-auto">
          <div class="text-success">{{ use_language.boostable_products }}</div>
          <v-data-table
            :headers="stockBoostHeaders"
            :items="haveStockBoostList"
            item-key="id"
            hide-default-footer
            class="packhai-border-table"
            :items-per-page="10000"
          >
            <template v-slot:item.item_name="{ item }">
              <div class="text-left">{{item.item_name}}</div>
            </template>
          </v-data-table>
          <v-divider class="py-5"/>
          <div class="text-danger">{{ use_language.non_boostable_products }}</div>
          <v-data-table
            :headers="stockBoostHeaders"
            :items="noStockBoostList"
            item-key="id"
            hide-default-footer
            class="packhai-border-table"
            :items-per-page="10000"
          >
            <template v-slot:item.item_name="{ item }">
              <div class="text-left">{{item.item_name}}</div>
            </template>
            <template v-slot:item.description="{ item }">
              <div>{{ use_language.not_have }} stock</div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn @click="btnPrepareProductToBoost" color="primary">{{use_language.confirm}}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- แสดงภาพ -->
    <v-dialog v-model="ShowPhoto" max-width="500">
      <v-card class="ma-0">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" class="text-center">
              <img class="hidden-md-and-up" :src="ShowPhotoLink" width="300">
              <img class="hidden-sm-and-down" :src="ShowPhotoLink" width="450">
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn text color="#1976d2" @click="Opentap(ShowPhotoLink)">{{use_language.newtab}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="#1976d2" @click="ShowPhoto = false">{{use_language.close}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2"; 
import Loading from "@/website/components/Loading";
import { shopService_dotnet, ecomService_dotnet } from "@/website/global";
import { AlertSuccess, AlertError } from "@/website/global_alert";
import { format_price, formatDate_thai2, isNumberWithDot, DateNowNotNull, Trim_value, Trim_rules, get_languages } from "@/website/global_function";
import { header_token } from '@/website/backend/token'

// const ecomService_dotnet = "https://dev-ecom.packhai-api-88.com/"
export default {
  name: 'FrontShopBootsItemShopee',

  components: { Loading },

  data() {
    return {
      page_loading: true,
      loading: false,
      staffShopID: JSON.parse(localStorage.getItem("staff_id")),
      shopID: JSON.parse(localStorage.getItem("shop_id")),
      header_token:{
        'Content-Type': 'application/json', 
        'Authorization': 'Bearer '+ localStorage.getItem('authorization_token')
      },
      ShowPhotoLink: null,
      ShowPhoto: false,

      //
      myShopeeShopID: null,
      search: { name: '', sku: '' },
      expanded: [],
      productTotal: 0,
      productMasterSelect: [],
      productMasterList: [],

      expandedBoost: [],
      productBoostTotal: 0,
      productBoostMasterSelect: [],
      productBoostMasterList: [],
      boostTimer: null,
      boostNow: Date.now(),
      dialogAddProductToBoost: false,

      dialogCheckStock: false,
      haveStockBoostList: [],
      noStockBoostList: [],
      stockLoading: false,

      isAutoBoost: false,
      isShowAutoBoost: true,
      idProductToBoostList: [],
      productToBookmark: [],

      isSaveChange: false,
    }
  },

  computed: {
    productMasterHeaders() {
      return [
        { align: "center", text: "", value: "data-table-select", sortable: false, width: "10px" },
        { align: "center", text: this.use_language.picture, value: "photoLink", sortable: false, width: "60px" },
        { align: "center", text: this.use_language.product, value: "name", sortable: false, width: "250px" },
        { align: "center", text: "SKU", value: "sku", sortable: false, width: "100px" },
        { align: "center", text: this.use_language.price, value: "salePrice", sortable: false, width: "20px" },
        { align: "center", text: this.use_language.button_more, value: "data-table-expand", sortable: false, width: "50px" }
      ]
    },
    productSubHeaders() {
      return [
        { align: "center", text: this.use_language.picture, value: "photoLink", sortable: false, width: "60px" },
        { align: "center", text: this.use_language.product, value: "name", sortable: false, width: "250px" },
        { align: "center", text: "SKU", value: "sku", sortable: false, width: "100px" },
        { align: "center", text: this.use_language.price, value: "salePrice", sortable: false, width: "20px" },
      ]
    },
    productBoostMasterHeaders() {
      return [
        { align: "center", text: "", value: "data-table-select", sortable: false, width: "10px" },
        { align: "center", text: "Bookmark", value: "isBookmark", sortable: false, width: "10px" },
        { align: "center", text: this.use_language.picture, value: "photoLink", sortable: false, width: "60px" },
        { align: "center", text: this.use_language.product, value: "name", sortable: false, width: "250px" },
        { align: "center", text: "SKU", value: "sku", sortable: false, width: "100px" },
        { align: "center", text: this.use_language.price, value: "salePrice", sortable: false, width: "20px" },
        { align: "center", text: this.use_language.time + " Boost", value: "finish", sortable: false, width: "100px" },
        { align: "center", text: this.use_language.button_more, value: "data-table-expand", sortable: false, width: "60px" }
      ]
    },
    stockBoostHeaders() {
      return [
        { align: "center", text: this.use_language.product, value: "item_name", sortable: false, width: "250px" },
        { align: "center", text: "SKU", value: "item_sku", sortable: false, width: "100px" },
        { align: "center", text: this.use_language.note, value: "description", sortable: false, width: "100px" },
      ]
    },
  },

  mounted() {
    this.boostTimer = setInterval(() => {
      this.boostNow = Date.now()
    }, 1000)
  },

  beforeDestroy() {
    clearInterval(this.boostTimer)
  },

  async created() {
    //เก็บภาษามาไว้ใน use_language
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    await this.getBoostProductListFromShopee()
    await this.getBoostProductList()
    this.page_loading = false;
  },

  watch: {

  },

  methods: {
    get_languages,
    format_price,
    AlertSuccess, 
    AlertError,

    async getBoostProductListFromShopee() {
      let response = await axios.post(
        ecomService_dotnet + "Shopee/get-boost-product-from-shopee",
        {"shopID": this.shopID},
        { headers: this.header_token }
      );
      return response.data
    },

    async getBoostProductList() {
      this.expanded = []
      this.productMasterSelect = []
      this.expandedBoost = []
      this.productBoostMasterSelect = []
      let response = await axios.post(
        ecomService_dotnet + "Shopee/get-boost-product-list-shopee",
        { 
          "marketplaceID": 0,
          "name": this.search.name,
          "sku": this.search.sku,
          "shopID": this.shopID,
          "skip": 0,
          "take": 10000
        },
        { headers: this.header_token }
      );
      this.productBoostTotal = response.data.boostTotalRows
      this.productBoostMasterList = response.data.productBoostList.sort((a, b) => b.isBookmark - a.isBookmark)
      this.isAutoBoost = response.data.isAutoBoost
      if (this.productBoostMasterList.filter(i => i.isBoostTable == true).length >= 5) {
        this.isShowAutoBoost = false
      }
    },

    async getProductList() {
      this.expanded = []
      this.productMasterSelect = []
      this.expandedBoost = []
      this.productBoostMasterSelect = []
      let response = await axios.post(
        ecomService_dotnet + "Shopee/get-product-list-shopee",
        { 
          "marketplaceID": 0,
          "name": this.search.name,
          "sku": this.search.sku,
          "shopID": this.shopID,
          "skip": 0,
          "take": 10000
        },
        { headers: this.header_token }
      );
      var productInBoost = this.productBoostMasterList.map(i => i.shopeeItemID)
      
      this.productTotal = response.data.totalRows
      this.productMasterList = response.data.productList.filter(i => !productInBoost.includes(i.shopeeItemID))
      if (this.productMasterList.length > 0) {
        this.myShopeeShopID = this.productMasterList[0].shopeeShopID
      }
    },

    async btnCheckStockShopee() {
      this.stockLoading = true
      var resList = []
      var idList = this.productMasterSelect.map(i => i.shopeeItemID)
      for (let i = 0; i < idList.length; i++) {
        resList.push(await this.functionCheckStock(idList[i]))
      }

      var continueStock = resList.filter(i => i.message == "success" && i.response != null && i.response.item_list != null).map(i => i.response.item_list[0])
      continueStock.forEach(e => {
        if (e.stock_info_v2 != null) {
          if (e.stock_info_v2.seller_stock[0].stock > 0) {
            this.haveStockBoostList.push(e)
          } else {
            this.noStockBoostList.push(e)
          }
        } else {
          this.noStockBoostList.push(e)
        }
      });

      if (this.noStockBoostList.length == 0) {
        await this.btnPrepareProductToBoost()
        this.dialogAddProductToBoost = false
      } else {
        this.dialogCheckStock = true
      }
      this.stockLoading = false
      
    },

    async functionCheckStock(itemId) {
      let response = await axios.post(
        ecomService_dotnet + "Shopee/get-product-detail-v2",
        {
          "shopeeShopID": String(this.myShopeeShopID),
          "itemID": String(itemId)
        },
        { headers: this.header_token }
      );
      return response.data
    },

    closeCheckStockShopee() {
      this.dialogCheckStock = false
      this.noStockBoostList = []
      this.haveStockBoostList = []
    },

    async btnPrepareProductToBoost() {
      var newProduct = []
      this.haveStockBoostList.forEach(e => {
        newProduct.push({
          id: 0,
          shopeeItemID: e.item_id,
          isBookmark: false,
          photoLink: e.image.image_url_list[0],
          name: e.item_name,
          sku: e.item_sku,
          salePrice: e.price_info[0].current_price,
          finish: null,
          shopeeVariationId: null,
          items: []

        })
      });
      if (newProduct.length > 0) {
        this.isSaveChange = true
      }
      this.productBoostMasterList = this.productBoostMasterList.concat(newProduct)
      this.closeProductForBoost()
      this.closeCheckStockShopee()
    },

    async btnPrepareRemoveProduct() {
      this.isSaveChange = true
      this.productBoostMasterList = this.productBoostMasterList.filter(
        x => !this.productBoostMasterSelect.some(y => y.shopeeItemID === x.shopeeItemID)
      );
    },

    async btnPrepareBookmark(item) {
      var bookmark = this.productToBookmark.find(i => i.shopeeItemID == item.shopeeItemID)
      if (bookmark == undefined) {
        this.productToBookmark.push({"shopeeItemID": item.shopeeItemID, "isBookmark": !item.isBookmark})
      } else {
        this.productToBookmark.find(i => i.shopeeItemID == item.shopeeItemID).isBookmark = !item.isBookmark
      }
      this.productBoostMasterList.find(i => i.shopeeItemID == item.shopeeItemID).isBookmark = !item.isBookmark
      this.productBoostMasterList = this.productBoostMasterList.sort((a, b) => b.isBookmark - a.isBookmark)
      this.isSaveChange = true
    },

    async btnSaveChanges() {
      this.loading = true
      var isPass1 = await this.btnAddToBoost()
      if (isPass1 == true) {
        var isPass2 = await this.btnRemoveFromBoost()
        if (isPass2 == true) {
          var isPass3 = await this.btnBookmark()
          if (isPass3 == true) {
            await this.getBoostProductList()
            this.AlertSuccess()
          } else {
            this.AlertError()
          }
        } else {
          this.AlertError()
        }
      } else {
        this.AlertError()
      }
      this.isSaveChange = false
      this.loading = false
    },

    async btnAddToBoost() {
      var idList = this.productBoostMasterList.filter(i => i.id == 0).map(i => i.shopeeItemID)
      if (idList.length == 0) {
        return true
      }
      let response = await axios.post(
        ecomService_dotnet + "Shopee/add-product-to-boost",
        { 
          "shopID": this.shopID,
          "shopeeShopID": this.myShopeeShopID,
          "productIDList": idList,
        },
        { headers: this.header_token }
      );
      if (response.data == "success") {
        return true
      } else {
        return false
      }
    },

    async btnRemoveFromBoost() {
      var idList = this.productBoostMasterSelect.filter(i => i.id != 0).map(i => i.shopeeItemID)
      if (idList.length == 0) {
        return true
      }
      let response = await axios.post(
        ecomService_dotnet + "Shopee/remove-product-from-boost",
        { 
          "shopeeShopID": this.productBoostMasterSelect[0].shopeeShopID,
          "productIDList": idList,
        },
        { headers: this.header_token }
      );
      if (response.data == "success") {
        return true
      } else {
        return false
      }
    },
    
    async btnBookmark() {
      if (this.productToBookmark.length == 0) {
        return true
      }
      let response = await axios.post(
        ecomService_dotnet + "Shopee/bookmark-product-shopee",
        { 
          "itemList": this.productToBookmark
        },
        { headers: this.header_token }
      );
      this.productToBookmark = []
      if (response.data == "success") {
        return true
      } else {
        return false
      }
    },

    async updateAutoBoost() {
      let response = await axios.post(
        ecomService_dotnet + "Shopee/update-auto-boost",
        {
          "shopID": this.shopID,
          "isAutoBoost": this.isAutoBoost
        },
        { headers: this.header_token }
      );
      if (response.data == "success") {
        this.AlertSuccess()
      } else {
        this.AlertError()
      }
    },

    async openProductForBoost() {
      this.loading = true
      await this.getProductList()
      this.dialogAddProductToBoost = true
      this.loading = false
    },

    closeProductForBoost() {
      this.productMasterSelect = []
      this.dialogAddProductToBoost = false
    },

    formatCountdown(finish) {
      const diff = new Date(finish).getTime() - this.boostNow

      if (diff <= 0) return "00:00:00"

      const h = String(Math.floor(diff / 3600000)).padStart(2, '0')
      const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0')
      const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0')

      return `${h}:${m}:${s}`
    },

    //
    OpenPhoto(Photo){
      this.ShowPhotoLink = Photo
      this.ShowPhoto = true
    },
    Opentap(photoLink){
      window.open(photoLink);
    },
  },
};
</script>